// Marques de performance du menu Evenements (carte/carrousel/liste/sheet).
// Purement observationnel : aucun de ces appels ne doit changer un
// comportement fonctionnel. Actif en dev par defaut ; activable en prod via
// REACT_APP_PERF_MARKS=1 pour un echantillon RUM controle (cf.
// docs/event-menu-apple-like-performance-execution-spec.md, section 8).
const ENABLED =
  process.env.NODE_ENV !== "production" || process.env.REACT_APP_PERF_MARKS === "1";

function hasPerformanceApi() {
  return typeof performance !== "undefined" && typeof performance.mark === "function";
}

export function markOnce(name, guardRef) {
  if (!ENABLED || !hasPerformanceApi()) return false;
  if (guardRef && guardRef.current) return false;
  try {
    performance.mark(name);
    if (guardRef) guardRef.current = true;
    return true;
  } catch {
    // Pas de fallback : une marque manquante ne doit jamais faire echouer l'app.
    return false;
  }
}

export function mark(name) {
  if (!ENABLED || !hasPerformanceApi()) return false;
  try {
    performance.mark(name);
    return true;
  } catch {
    // Pas de fallback : une marque manquante ne doit jamais faire echouer l'app.
    return false;
  }
}

export function measure(name, startMark, endMark) {
  if (!ENABLED || !hasPerformanceApi() || typeof performance.measure !== "function") return null;
  try {
    const result = performance.measure(name, startMark, endMark);
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.debug(`[perf] ${name}: ${result.duration.toFixed(1)}ms`);
    }
    return result;
  } catch {
    // Les deux marques peuvent ne pas exister encore (ex. navigation interrompue).
    return null;
  }
}
